import { ColorContext } from 'App';
import flood from 'assets/FloodStageIcons/stage_online.png';
import floodcam from 'assets/FloodStageIcons/stage_online_camera.png';
import LocationSetter from 'components/AlertCreator/components/LocationSetter';
import Cookies from 'js-cookie';
import L from 'leaflet';
import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Container } from 'react-bootstrap';
import { Circle, MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import { GetDeviceTypeString } from 'utils/stringUtils';

const floodIcon = L.icon({
  iconUrl: flood,
  iconSize: [25, 41],
});

const floodCameraIcon = L.icon({
  iconUrl: floodcam,
  iconSize: [25, 41],
});

export default function RadialAlertMap({
  arrayOfDevices,
  selectedDevice,
  radius,
  setSelectedDevice,
}) {
  const [userPosition, setUserPosition] = useState(null);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      setUserPosition([position.coords.latitude, position.coords.longitude]);
    });
  }, []);

  const theme = useContext(ColorContext);

  const [mapCenter, setMapCenter] = useState([Cookies.get('latitude'), Cookies.get('longitude')]);

  useEffect(() => {
    if (selectedDevice && selectedDevice.location.lat && selectedDevice.location.lng) {
      setMapCenter([selectedDevice.location.lat, selectedDevice.location.lng]);
    }
  }, [selectedDevice]);

  useEffect(() => {
    if (Cookies.get('latitude') && Cookies.get('longitude')) {
      setUserPosition([Cookies.get('latitude'), Cookies.get('longitude')]);
      return;
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setUserPosition([position.coords.latitude, position.coords.longitude]);
      });
    } else {
      setUserPosition([0, 0]);
    }
  }, []);

  return (
    <Container fluid className="p-0">
      {userPosition && (
        <div className="d-flex justify-content-center">
          <div
            className="position-relative w-100 rounded-2 shadow overflow-hidden"
            style={{ maxWidth: 720, height: 'clamp(320px, 50vh, 640px)' }} // key line
          >
            <MapContainer
              center={mapCenter}
              zoom={13}
              className="position-absolute top-0 start-0 w-100 h-100"
            >
              <LocationSetter center={mapCenter} zoom={16} />
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={userPosition}>
                <Popup>
                  <div className="fw-semibold">Your location</div>
                </Popup>
              </Marker>

              {selectedDevice && <Circle center={mapCenter} radius={radius * 0.3048} />}

              {arrayOfDevices
                .filter((f) => GetDeviceTypeString(f).toLowerCase() === 'flood stage')
                .filter((device) => device.location?.lat && device.location?.lng)
                .map((device) => (
                  <Marker
                    key={device.node_id}
                    position={[device.location.lat, device.location.lng]}
                    icon={
                      device.imgList && device.imgList.length > 0 && device.imgList[0].url
                        ? floodCameraIcon
                        : floodIcon
                    }
                  >
                    <Popup>
                      <Card className="border-0">
                        <Card.Body className="p-2">
                          <Card.Title className="h6 mb-2">Node ID: {device.node_id}</Card.Title>
                          <div className="small text-muted">
                            <div>Status: {device.status}</div>
                            <div>Type: {device.type}</div>
                          </div>

                          {device.imgList && device.imgList.length > 0 && device.imgList[0].url && (
                            <div className="mt-2">
                              <img
                                src={device.imgList[0].url}
                                alt="Device"
                                className="img-fluid rounded"
                                style={{ maxHeight: 120, objectFit: 'cover' }}
                              />
                            </div>
                          )}

                          <Button
                            variant="primary"
                            size="sm"
                            className="w-100 mt-2"
                            onClick={() => setSelectedDevice(device.node_id)}
                          >
                            Use this device
                          </Button>
                        </Card.Body>
                      </Card>
                    </Popup>
                  </Marker>
                ))}
            </MapContainer>
          </div>
        </div>
      )}
    </Container>
  );
}
